import { render, staticRenderFns } from "./CustomerViewContactsAddContactModal.vue?vue&type=template&id=b393eb2c&"
import script from "./CustomerViewContactsAddContactModal.vue?vue&type=script&lang=js&"
export * from "./CustomerViewContactsAddContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports